import $ from 'jquery';

let doingAjax = false;

$( '.js-archive-calendar-year' ).on( 'click', 'a', function(e) {
	e.preventDefault();

	const $year = $( this );

	if ( $year.parent().hasClass( 'is-selected' ) ) {
		return;
	}

	const $wrapper = $year.closest( '.js-archive-calendar-wrapper' );
	const $loader = $wrapper.find( '.js-loader' );

	$wrapper.find( '.js-archive-calendar-year' ).find( '.is-selected' ).removeClass( 'is-selected' );
	$year.parent().addClass( 'is-selected' );

	if ( ! doingAjax ) {
		$.ajax( {
			url: $year.attr( 'href' ),
			method: 'get',
			data: {
				'securelist-2020-ajax': 'true',
			},
			beforeSend: function() {
				doingAjax = true;

				$wrapper.find( '.js-current-year' ).text( $year.text() );
				$wrapper.find( '.js-archive-calendar-month' ).addClass( 'u-hidden' );
				$wrapper.find( '.js-archive-calendar-month' ).empty();
				$( $loader ).addClass( 'is-loading' );
			},
			success: function( data ) {
				const $container = $( $.parseHTML( data ) );
				const $months = $container.find( '.js-archive-calendar-month > li' );

				if ( $months.length ) {
					$wrapper.find( '.js-current-year' ).text( $year.text() );
					$wrapper.find( '.js-archive-calendar-month' ).removeClass( 'u-hidden' );
					$wrapper.find( '.js-archive-calendar-month' ).empty();
					$wrapper.find( '.js-archive-calendar-month' ).append( $months );
				}

				$( $loader ).removeClass( 'is-loading' );
				doingAjax = false;
			},
			error: function() {
				$( $loader ).removeClass( 'is-loading' );
				doingAjax = false;
			}
		} );
	}
} );

$( '.js-archive-calendar-month' ).on( 'click', 'a', function(e) {
	e.preventDefault();

	if ( $( this ).parent().hasClass( 'is-selected' ) ) {
		return;
	}

	const $wrapper = $( this ).closest( '.js-archive-calendar-wrapper' );

	$wrapper.find( '.js-archive-calendar-month' ).find( '.is-selected' ).removeClass( 'is-selected' );
	$( this ).parent().addClass( 'is-selected' );

	$wrapper.find( '.js-confirm-calendar-selection' ).prop( 'disabled', false );
} );

$( '.js-confirm-calendar-selection' ).on( 'click', function() {
	const location = $( this ).closest( '.js-archive-calendar-wrapper' ).find( '.js-archive-calendar-month' ).find( '.is-selected a' ).attr( 'href' );

	if ( location ) {
		window.location.href = location;
	}
} );
